import { usePortalLang } from '../hooks/usePortalLang';

/**
 * Tiny EN | ES pill used in customer-portal headers.
 * Light theme = transparent text on dark bg. Dark theme = on-white card variant.
 */
export function PortalLanguageToggle({ variant = 'dark', className = '' }) {
  const { lang, setLang } = usePortalLang();
  const isDark = variant === 'dark';
  const wrapCls = isDark
    ? 'bg-white/10 border-white/15'
    : 'bg-gray-100 border-gray-200';
  const inactiveCls = isDark ? 'text-white/70 hover:text-white' : 'text-gray-500 hover:text-gray-900';
  const activeCls = isDark ? 'bg-white text-gray-900' : 'bg-white text-gray-900 shadow-sm';

  return (
    <div
      className={`inline-flex items-center border rounded-full overflow-hidden text-[11px] font-bold ${wrapCls} ${className}`}
      data-testid="portal-lang-toggle"
    >
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`px-2.5 py-1 transition-colors ${lang === 'en' ? activeCls : inactiveCls}`}
        data-testid="portal-lang-en"
        aria-pressed={lang === 'en'}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang('es')}
        className={`px-2.5 py-1 transition-colors ${lang === 'es' ? activeCls : inactiveCls}`}
        data-testid="portal-lang-es"
        aria-pressed={lang === 'es'}
      >
        ES
      </button>
    </div>
  );
}
